import React from 'react';
import AdminLayout from '../../../../components/Layout/AdminLayout';
import EditRideFare from './EditRideFare';
import messages from '../../../../locale/messages';

function action({ store, params, intl }) {
  const title = intl.formatMessage(messages.editRideFare);

  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  return {
    title,
    component: (
      <AdminLayout>
        <EditRideFare title={title} id={Number(params.id)} />
      </AdminLayout>
    ),
  };
}

export default action;
